import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ViewExtraLarge, Viewport } from 'bernie-view';

import { DisplayAd } from 'constants/ads';

import { MesoDisplayAd } from './meso-display-ad';
import { MesoTrigger } from './meso-trigger';

interface MesoSideRailProps {
  pageName: string;
}

const breakpointsFrameworkExperiment = 'MeSo_PWA_Breakpoints_Framework';

export class MesoSideRail extends React.Component<MesoSideRailProps> {
  public render() {
    const { pageName } = this.props;

    return (
      <AbacusExperiment name={breakpointsFrameworkExperiment}>
        <AbacusControl>
          <Viewport>
            <ViewExtraLarge>
              <>
                <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_R1} />
                <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_RM} />
                <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_R2} />
                <MesoTrigger pageName={pageName} />
              </>
            </ViewExtraLarge>
          </Viewport>
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <>
            <meso-display-ad class="ad-div display-ad uitk-grid" uci="R1" />
            <meso-display-ad class="ad-div display-ad uitk-grid" uci="RM" />
            <meso-display-ad class="ad-div display-ad uitk-grid sticky-top__with-navbar" uci="R2" />
            <MesoTrigger pageName={pageName} />
          </>
        </AbacusVariant>
      </AbacusExperiment>
    );
  }
}
